import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import moment from "moment";
import {
    SidePanel,
    SidePanelHeader,
    SidePanelBody,
    SidePanelFooter,
    Button,
    PillsGroup,
    TimeFrame,
    useTimeFrameComponent
} from '@gpstrackit/gtc-react-controls';

import TagsManage from 'Modules/.common/components/TagsManage';

import {
    Grid
} from "@mui/material";

import {
    reset,
    searchDynamicForms,
    openAdvancedFilters,
    closeAdvancedFilters
} from '../redux/slice';

const DynamicFormsAdvancedFilters = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const states = [
        { id: -1, label: messages["dynamicFormsMain_all"] },
        { id: 0, label: messages["dynamicFormsMain_inactive"] },
        { id: 1, label: messages["dynamicFormsMain_active"] }
    ];

    const defaultFrame = "last7days"

    const timeFrameOptions = [
        { id: "today", label: messages['date_last_today'] },
        { id: "yesterday", label: messages['date_last_yesterday'] },
        { id: "last7days", label: messages['date_last_7days'] },
        { id: "last30Days", label: messages['date_last_30days'] },
        { id: "custom", label: messages['date_custom'] },
    ];

    const timeFrame = useTimeFrameComponent(timeFrameOptions, defaultFrame);

    const currentFilters = useSelector(state => state.dynamicFormsRedux.filters);
    const open = useSelector(state => state.dynamicFormsRedux.openAdvancedFilters);
    const loading = useSelector(state => state.dynamicFormsRedux.loading);
    const user = useSelector((state) => state.securityRedux.user);

    const [filters, setFilters] = useState({ status: -1, tags: [] });

    const clearFilters = useCallback(() => {
        timeFrame.defaultvalue(defaultFrame);
        let newFilters = { status: -1, tags: [] }
        setFilters(newFilters);
        dispatch(searchDynamicForms({
            ...currentFilters,
            ...newFilters,
            tagIds: [],
            offset: 0,
            dateRange: {
                start: moment().subtract(7, 'days').startOf('day').toDate(),
                end: moment.max(moment()).endOf('day').toDate()
            }
        }));

        if (props.resetTable) props.resetTable();
    });

    const apply = useCallback(() => {
        const { startDate, endDate } = timeFrame;
        dispatch(searchDynamicForms({
            ...currentFilters,
            ...filters,
            tagIds: filters?.tags?.map(tag => tag?.id),
            offset: 0,
            dateRange: {
                start: startDate.toISOString(),
                end: endDate.toISOString()
            }
        }));

        if (props.resetTable) props.resetTable();
    });

    return (
        <SidePanel
            isOpen={open}
            onToggle={() => {
                if (!open) {
                    dispatch(openAdvancedFilters())
                } else {
                    dispatch(closeAdvancedFilters())
                }
            }}
            style={{ zIndex: 2, width: '400px', transform: 'translateX(400px)' }}
            contentStyle={{ overflowY: "hidden" }}
        >
            <SidePanelHeader>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <h2 style={{ margin: 0 }}>
                            {messages['dynamicFormsMain_advancedFilters']}
                        </h2>
                        <span
                            className='btn-link'
                            onClick={clearFilters}
                        >
                            {messages['dynamicFormsMain_clearAll']}
                        </span>
                    </Grid>
                </Grid>
            </SidePanelHeader>

            <SidePanelBody
                style={{
                    height: "auto"
                }}
            >
                <div>
                    {
                        open &&
                        <div style={{ marginTop: 10, marginBottom: 10 }}>
                            <TagsManage
                                onlyTags={true}
                                enableSelectAll={true}
                                mode="list"
                                height={280}
                                label={messages["dynamicFormsDesign_tags"]}
                                placeholder={messages["search"]}
                                value={filters?.tags || []}
                                onChange={(values) => setFilters({ ...filters, tags: values })}
                            />
                        </div>
                    }

                    {/** 
                    <div>
                        <TimeFrame
                            {...timeFrame}
                            label={messages['dynamicFormsMain_timeframe']}
                            placeholder={messages['dynamicFormsMain_timeframe']}
                            customRangeDate={90}
                            maxDate={moment()}
                            filterSwitch={false}
                            withTime={true}
                            dateFormat={user?.dateformat || "MM/DD/YYYY hh:mm A"}
                        />
                    </div>
                    */}

                    <div style={{ paddingTop: 15 }}>
                        <div style={{ paddingTop: '10px', display: "flex" }}>
                            <PillsGroup
                                label={messages['dynamicFormsMain_status']}
                                options={states}
                                multicolor={false}
                                values={states?.filter(s => s.id === filters.status)}
                                onChange={(newItem) => setFilters({ ...filters, status: newItem[0].id })}
                                size="dynamic"
                            />
                        </div>
                    </div>
                </div>
            </SidePanelBody>

            <SidePanelFooter>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                        variant="secondary"
                        style={{ marginRight: 8 }}
                        onClick={() => dispatch(closeAdvancedFilters())}
                    >
                        {messages["cancel"]}
                    </Button>

                    <Button
                        variant="primary"
                        disabled={loading}
                        onClick={apply}
                    >
                        {messages["apply"]}
                    </Button>
                </div>
            </SidePanelFooter>
        </SidePanel>
    )
};

export default DynamicFormsAdvancedFilters;